const Resolutions = {
    '1080': {
        height: 1080,
        width: 1920
    },
    '180': {
        height: 180,
        width: 320
    },
    '2160': {
        height: 2160,
        width: 3840
    },
    '240': {
        height: 240,
        width: 320
    },
    '360': {
        height: 360,
        width: 640
    },
    '480': {
        height: 480,
        width: 640
    },
    '4k': {
        height: 2160,
        width: 3840
    },
    '540': {
        height: 540,
        width: 960
    },
    '720': {
        height: 720,
        width: 1280
    },
    'fullhd': {
        height: 1080,
        width: 1920
    },
    'hd': {
        height: 720,
        width: 1280
    },
    'qhd': {
        height: 540,
        width: 960
    },
    'vga': {
        height: 480,
        width: 640
    }
};

export default Resolutions;